<div class="modal-body wrapper-modal main-container px-0 px-md-4 pt-4">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <div class="title pt-3 pt-sm-0">Inspección preoperacional de candado satelital</div>
    <div class="py-1 px-2 col-12 alert mb-4 text-bold text-center" *ngIf="data?.inspection?.id" [ngClass]="{'warning-text': !utils.isDefined(data?.inspection?.approval),
              'success-text': data?.inspection?.approval,
              'danger-text': utils.isDefined(data?.inspection?.approval) && !data?.inspection?.approval}">
        <i class="fas"
            [ngClass]="{'fa-check-circle': data?.inspection?.approval, 'fa-exclamation-circle': !data?.inspection?.approval}"></i>
        {{utils.isDefined(data?.inspection?.approval)? data?.inspection?.approval ? 'Aprobado' : 'Rechazado' : 'Sin
        aprobar'}}
    </div>

    <form *ngIf="isPreoperationalInspection || isViewInspection" [formGroup]="preoperationalInspectionForm">
        <mat-card-content class="d-flex flex-wrap my-3">
            <div class="pl-0 col-12">
                <label class="label-field">
                    Creado y aprobado por<span *ngIf="!isViewInspection" class="asterisk">*</span>
                </label>
                <input type="text" class="form-control" [value]="createdAndApprovedBy" readonly>
            </div>
            <div class="pl-0 col-12">
                <mat-form-field appearance="standard" class="w-100">
                    <mat-label>¿Dispositivo reportando?<span *ngIf="!isViewInspection"
                            class="asterisk">*</span></mat-label>
                    <mat-select formControlName="deviceReporting" placeholder="Seleccione una opción">
                        <mat-option *ngFor="let option of deviceReportingOptions" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="preoperationalInspectionForm.get('deviceReporting').errors?.required">
                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="pl-0 col-12">
                <mat-form-field appearance="standard" class="w-100">
                    <mat-label>Nivel de carga del dispositivo<span *ngIf="!isViewInspection"
                            class="asterisk">*</span></mat-label>
                    <mat-select formControlName="deviceChargeLevel" placeholder="Seleccione una opción">
                        <mat-option *ngFor="let option of deviceChargeLevelOptions" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="preoperationalInspectionForm.get('deviceChargeLevel').errors?.required">
                        {{ utils.giveMessageError('MANDATORY_FIELD') }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="pl-0 col-12">
                <div class="alert alert-warning" *ngIf="showErrorMessages">
                    {{ showErrorMessages }}
                </div>
            </div>
        </mat-card-content>

        <div class="d-flex flex-wrap mt-2 mb-3">
            <h5 class="text-center col-12 text-bold">Garantía de responsabilidad</h5>
            <label class="mr-3 text-center col-12">
                Yo, <b>{{createdAndApprovedBy}}</b>, garantizo que el candado satelital con IMEI
                <b>{{data?.satelliteLock?.imei ||
                    '-'}}</b> se encuentra en óptimas condiciones de funcionamiento para prestar
                el servicio de monitoreo de seguridad por carretera.
            </label>
            <mat-checkbox class="my-3 col-12" [formControl]="preoperationalInspectionForm.get('driverWarranty')">
                <span class="text-bold text-break">
                    Confirmo que la información proporcionada es correcta y asumo total responsabilidad.
                </span>
            </mat-checkbox>
        </div>

        <mat-card-actions *ngIf="!isViewInspection">
            <button mat-raised-button color="primary" class="primary-secondary button-width-auto"
                (click)="dialogRef.close()">
                Cancelar
            </button>
            <button mat-raised-button color="primary" class="button-width-auto"
                (click)="savePreoperationalInspection()">
                Guardar
            </button>
        </mat-card-actions>

        <mat-card-actions *ngIf="isViewInspection">
            <button mat-raised-button color="primary" class="primary-secondary button-width-auto"
                (click)="dialogRef.close()">
                Cerrar
            </button>
            <button *ngIf="canApproveInspection" mat-raised-button color="primary" class="button-width-auto"
                (click)="approveRejectedInspection()">
                Aprobar inspección
            </button>
        </mat-card-actions>
    </form>
</div>